import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FaInfoCircle } from "react-icons/fa";

import { calculatePercentage } from "@/utils/calculatePercentage";
import { getIndicatorClassificationColorClassName, IndicatorEsbEnum } from "@/utils/indicatorsEsb";
import { ResumeIndicatorB5Data } from "@/services/esus/indicator/esb/b5/getResumeIndicatorB5";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

type IndicatorEsbB5ResumeProps = {
	resume: ResumeIndicatorB5Data;
};

export function IndicatorEsbB5Resume({ resume }: Readonly<IndicatorEsbB5ResumeProps>) {
	const indicatorPercentage = calculatePercentage(
		resume.totalPreventProcedures,
		resume.totalProcedures
	);

	return (
		<Row className="mx-0">
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Total de procedimentos"
					value={resume.totalProcedures.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Total de procedimentos"
							message="Quantidade de procedimentos realizados no período"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Total de procedimentos preventivos"
					value={resume.totalPreventProcedures.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Total de procedimentos preventivos"
							message="Quantidade de procedimentos preventivos realizados no período"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Outros procedimentos"
					value={(
						resume.totalProcedures - resume.totalPreventProcedures
					).toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Outros procedimentos"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Quantidade de procedimentos não preventivos realizados no <br />
								período.
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Classificação"
					value={`${indicatorPercentage}%`}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue={`text-${getIndicatorClassificationColorClassName(
						IndicatorEsbEnum.B5,
						indicatorPercentage
					)}`}
					metaData={
						<CardOverlayTrigger
							header="Classificação"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Percentual de procedimentos preventivos em relação <br />
								ao total de procedimentos do período.
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
		</Row>
	);
}
